import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';

import { AuthService } from './auth.service';
import { EstadoMantenimientoService } from '../mantenimiento-modulos/estado-mantenimiento.service';
import { RUTA_AVISO, normaliza } from '../mantenimiento-modulos/reglas';

@Injectable()
export class AuthGuard  {

  /** Mantenimiento de módulos (16/10/2026): lo que está en mantenimiento no se abre. */
  private readonly mantenimiento = inject(EstadoMantenimientoService);

  constructor(private router: Router, private authService: AuthService) {}

  /**
   * Con sesión, y si la pantalla está en mantenimiento, el aviso en su lugar
   * (para cualquiera, también para quien administra el mantenimiento). Si el
   * servidor no contesta, se deja pasar: el mantenimiento nunca traba la navegación.
   */
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean | UrlTree> {
    if (!this.authService.isAuthenticated()) {
        this.router.navigate(['security/login'], { queryParams: { returnUrl: state.url }});
        return false;
    }
    if (normaliza(state.url) === RUTA_AVISO) {
      return true;
    }
    return this.mantenimiento.asegurar().pipe(
      map(() => {
        const modulo = this.mantenimiento.porRuta(state.url);
        return this.mantenimiento.bloquea(modulo)
          ? this.router.createUrlTree(['/' + RUTA_AVISO], { queryParams: { m: modulo.clave } })
          : true;
      }),
    );
  }
}
